import {
  donedealGateway,
  donedealServicesGateway,
} from './api-utils/commonApiUtils';
import type { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import type {
  HistoryCheckPayload,
  HistoryCheckResponse,
} from './types/historyCheckApiTypes';

import type { FreeHistoryCheckPayload } from './types/freeHistoryCheckApiTypes';

async function getHistoryCheck(
  payload: HistoryCheckPayload,
  headers: IncomingHttpHeaders,
): Promise<AxiosResponse<HistoryCheckResponse>> {
  return await donedealGateway.post('/ddapi/v1/orders/history-check', payload, {
    headers,
  });
}

async function getFreeHistoryCheck(
  payload: FreeHistoryCheckPayload,
  headers: IncomingHttpHeaders & {
    userID: string;
  },
): Promise<AxiosResponse<void>> {
  return await donedealServicesGateway.post(
    '/ddapi/v1/orders/free-history-check',
    payload,
    {
      headers,
    },
  );
}

export const historyCheckApi = { getHistoryCheck, getFreeHistoryCheck };
